import React, {useState} from 'react';
import {checkNullStr, isBoolTrue} from "../utils/ReactUtils";

const Image = ({
                   className = "",
                   wrapperClassName = "",
                   src,
                   errorSrc,
                   objectFit = "cover",
                   id,
                   width,
                   height,
                   maxWidth,
                   maxHeight,
                   transition = true,
                   disableDrag = false,
                   alt = '',
                   style = {},
                   wrapperStyle = {},
                   onError,
                   ...rest
               }) => {
    const TAG = "Image";

    const [errorOccurred, setErrorOccurred] = useState(false);

    return (<>
            <div className={`m-0x p-0 d-flex jc-center al-center ${wrapperClassName} ${isBoolTrue(disableDrag) ? 'select-none' : ''}`}
                 style={{...wrapperStyle}}>
                <img
                    src={(errorOccurred && checkNullStr(errorSrc)) ? errorSrc : src}
                    className={`${isBoolTrue(transition ? 'transition-lg' : '')} object-fit-${objectFit} ${className}`}
                    id={id}
                    width={width}
                    height={height}
                    style={{maxHeight: maxHeight, maxWidth: maxWidth, ...style}}
                    onDrag={(e) => isBoolTrue(disableDrag) && e.preventDefault()}
                    onClick={(e) => isBoolTrue(disableDrag) && e.preventDefault()}
                    onContextMenu={(e) => isBoolTrue(disableDrag) && e.preventDefault()}
                    onDrop={(e) => isBoolTrue(disableDrag) && e.preventDefault()}
                    onDragEnter={(e) => isBoolTrue(disableDrag) && e.preventDefault()}
                    onDragOver={(e) => isBoolTrue(disableDrag) && e.preventDefault()}
                    onDragCapture={(e) => isBoolTrue(disableDrag) && e.preventDefault()}
                    onDragEnterCapture={(e) => isBoolTrue(disableDrag) && e.preventDefault()}
                    onDragStart={(e) => isBoolTrue(disableDrag) && e.preventDefault()}
                    alt={alt}
                    onChange={() => {
                        setErrorOccurred(false);
                    }}
                    onError={() => {
                        setErrorOccurred(true);
                        if (onError) onError();
                    }}
                    {...rest}/>
            </div>
        </>
    )

    function fun() {

    }
}
export default Image;
